import {AbstractType, getTemplate} from "./AbstractType";
import {TParameterType} from "../index";

export let template = getTemplate();

export class viewModel extends AbstractType {
    protected override parameterTypes: TParameterType[] = ['static', 'syncfield-id', 'text', 'boolean', 'text'];
}
